// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"928cf14a","404":"8307e64f","444":"d11ce140","787":"89cd4688"}[chunkId] + ".chunk.js";
};